import React, { useEffect, useState } from "react";
import { addressServer } from "../../config";
import pdf from "../../img/pdf.svg";
import TopImage from "../../components/TopImage";
import imgfile178scaled from "../../img/file_178-scaled.jpg";

const type = {
  pdf,
};

export default function TCRates() {
  const [documents, setDocuments] = useState([]);
  const [isLoading,setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${addressServer}/api/tp-tarify-na-tp?populate=*`)
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        setDocuments(data.data);
      })
      .catch((err) => {
        console.log(err);
        setDocuments([]);
      });
  }, []);

  return (
    <div className="page-grid__content" id="content">
      <TopImage image={imgfile178scaled} title={"Тарифы на ТП"} />
      <div>
        <div className="text-area">
          <p>
            Порядок расчета платы за технологическое присоединение для всех
            групп потребителей, копии решений органа исполнительной власти
            субъекта Российской Федерации в области государственного
            регулирования цен (тарифов) об установлении платы за технологическое
            присоединение в отношении территориальных сетевых организаций, а
            также копия решения федерального органа исполнительной власти в
            области государственного регулирования цен (тарифов) по установлению
            платы за технологическое присоединение в отношении организации по
            управлению единой национальной (общероссийской) электрической сетью,
            порядок оплаты по договору об осуществлении технологического
            присоединения к электрическим сетям, особенности внесения платы
            отдельными группами потребителей, предусмотренные законодательством
            Российской Федерации.
          </p>

          <p>
            <b>
              Положения о размере платы за технологическое присоединение,
              указанные в первом абзаце, не могут быть применены в следующих
              случаях:
            </b>
          </p>
          <ul>
            <li>
              <p>
                при технологическом присоединении энергопринимающих устройств,
                принадлежащих лицам, владеющим земельным участком по договору
                аренды, заключенному на срок не более одного года, на котором
                расположены присоединяемые энергопринимающие устройства;
              </p>
            </li>
            <li>
              <p>
                при технологическом присоединении энергопринимающих устройств,
                расположенных в жилых помещениях многоквартирных домов.
              </p>
            </li>
          </ul>
          <p>
            <b>
              Согласно п. 7 Методических указаний по определению размера платы
              за технологическое присоединение к электрическим сетям,
              утвержденных приказом ФСТ РФ от 11 сентября 2012 г. N 209-э/1,
              органами исполнительной власти субъектов Российской Федерации в
              области государственного регулирования тарифов для расчета платы
              за технологическое присоединение к территориальным
              распределительным сетям утверждаются на период регулирования:
            </b>
          </p>
          <ul>
            <li>
              <p>стандартизированные тарифные ставки;</p>
            </li>
            <li>
              <p>
                ставки за единицу максимальной мощности (руб./кВт) на период
                регулирования;
              </p>
            </li>
            <li>
              <p>формула платы за технологическое присоединение.</p>
            </li>
          </ul>
          <p>
            Лицо, которое имеет намерение осуществить технологическое
            присоединение к электрическим сетям, вправе самостоятельно выбрать
            вид ставки платы за технологическое присоединение. Выбор ставки
            платы осуществляется заявителем на стадии заключения договора об
            осуществлении технологического присоединения. В случае, если
            заявитель не выбрал вид ставки, сетевая организация вправе
            самостоятельно выбрать ставку и произвести расчет размера платы за
            технологическое присоединение.
          </p>
          <p>
            <b>
              Согласно Правил внесение платы заявителями, юридическими лицами
              или индивидуальным предпринимателем в целях технологического
              присоединения по одному источнику электроснабжения
              энергопринимающих устройств, максимальная мощность которых
              составляет свыше 15 до 150 кВт включительно (с учетом ранее
              присоединенных в данной точке присоединения энергопринимающих
              устройств) осуществляется в следующем порядке:
            </b>
          </p>
          <p></p>
          <ul>
            <li>
              <p>
                15 процентов платы за технологическое присоединение вносятся в
                течение 15 дней с даты заключения договора;
              </p>
            </li>
            <li>
              <p>
                30 процентов платы за технологическое присоединение вносятся в
                течение 60 дней с даты заключения договора, но не позже даты
                фактического присоединения;
              </p>
            </li>
            <li>
              <p>
                45 процентов платы за технологическое присоединение вносятся в
                течение 15 дней со дня фактического присоединения;
              </p>
            </li>
            <li>
              <p>
                10 процентов платы за технологическое присоединение вносятся в
                течение 15 дней со дня подписания акта об осуществлении
                технологического присоединения.
              </p>
            </li>
          </ul>
          <p></p>
          <p>
            <b>
              Для заявителей, максимальная мощность энергопринимающих устройств
              которых составляет менее 670 кВт, внесение платы за
              технологическое присоединение (за исключением случаев,
              урегулированных предыдущим абзацем осуществляется в следующем
              порядке:
            </b>
          </p>
          <p></p>
          <ul>
            <li>
              <p>
                10 процентов платы за технологическое присоединение вносятся в
                течение 15 дней со дня заключения договора;
              </p>
            </li>
            <li>
              <p>
                30 процентов платы за технологическое присоединение вносятся в
                течение 60 дней со дня заключения договора;
              </p>
            </li>
            <li>
              <p>
                20 процентов платы за технологическое присоединение вносятся в
                течение 180 дней со дня заключения договора;
              </p>
            </li>
            <li>
              <p>
                30 процентов платы за технологическое присоединение вносятся в
                течение 15 дней со дня фактического присоединения;
              </p>
            </li>
            <li>
              <p>
                10 процентов платы за технологическое присоединение вносятся в
                течение 10 дней со дня подписания акта об осуществлении
                технологического присоединения.
              </p>
            </li>
          </ul>
          <p></p>
          <p>
            В отношении заявителей, юридических лиц или индивидуальных
            предпринимателей в целях технологического присоединения по одному
            источнику электроснабжения энергопринимающих устройств, максимальная
            мощность которых составляет свыше 15 до 150 кВт включительно (с
            учетом ранее присоединенных в данной точке присоединения
            энергопринимающих устройств), в договоре (по желанию таких
            заявителей) предусматривается беспроцентная рассрочка платежа в
            размере 95 процентов платы за технологическое присоединение с
            условием ежеквартального внесения платы равными долями от общей
            суммы рассрочки на период до 3 лет с даты подписания сторонами акта
            об осуществлении технологического присоединения.
          </p>
        </div>
        <br />

        {/* Оставшаяся часть статического текста */}

        {/* Динамическое отображение документов */}
        <div className="page-grid__content">
          {/* <h2>Документы:</h2> */}
          <ul>
            {documents &&
              documents &&
              documents.files?.sort((a, b) => {
                  return (
                    parseInt(a.name, 10) -
                    parseInt(b.name, 10)
                  );
                })
                .map((item, index) => (
                  <li key={index} className="page-grid__content__li">
                    <a
                      className="doc-line"
                      href={`${addressServer}${item.url}`}
                      download=""
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <div className="doc-line__wrap-icon">
                        <img
                          src={type[item.ext.slice(1)]}
                          alt={`icon ${item.ext.slice(1)}`}
                        />
                      </div>
                      <div className="doc-line__wrap-text">
                        <span className="doc-line__name">
                          {index + 1}. {item.name}
                        </span>
                        <span className="doc-line__file-info">
                          {Number(item.size) > 1000
                            ? `${(item.size / 1000).toFixed(2)} МБ`
                            : `${Math.round(item.size)} КБ`}
                        </span>
                      </div>
                    </a>
                  </li>
                ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

// import React from "react";

// import { addressServer } from "../../config";
// import pdf from "../../img/pdf.svg";

// export default function TCRates() {
//   return (
//     <div className="page-grid__content" id="content">
// <div className="text-area">
//   <p>
//     Порядок расчета платы за технологическое присоединение для всех групп
//     потребителей, копии решений органа исполнительной власти субъекта
//     Российской Федерации в области государственного регулирования цен
//     (тарифов) об установлении платы за технологическое присоединение в
//     отношении территориальных сетевых организаций, а также копия решения
//     федерального органа исполнительной власти в области государственного
//     регулирования цен (тарифов) по установлению платы за технологическое
//     присоединение в отношении организации по управлению единой
//     национальной (общероссийской) электрической сетью, порядок оплаты по
//     договору об осуществлении технологического присоединения к
//     электрическим сетям, особенности внесения платы отдельными группами
//     потребителей, предусмотренные законодательством Российской Федерации.
//   </p>

//   <p>
//     <b>
//       Положения о размере платы за технологическое присоединение,
//       указанные в первом абзаце, не могут быть применены в следующих
//       случаях:
//     </b>
//   </p>
//   <ul>
//     <li>
//       <p>
//         при технологическом присоединении энергопринимающих устройств,
//         принадлежащих лицам, владеющим земельным участком по договору
//         аренды, заключенному на срок не более одного года, на котором
//         расположены присоединяемые энергопринимающие устройства;
//       </p>
//     </li>
//     <li>
//       <p>
//         при технологическом присоединении энергопринимающих устройств,
//         расположенных в жилых помещениях многоквартирных домов.
//       </p>
//     </li>
//   </ul>
//   <p>
//     <b>
//       Согласно п. 7 Методических указаний по определению размера платы за
//       технологическое присоединение к электрическим сетям, утвержденных
//       приказом ФСТ РФ от 11 сентября 2012 г. N 209-э/1, органами
//       исполнительной власти субъектов Российской Федерации в области
//       государственного регулирования тарифов для расчета платы за
//       технологическое присоединение к территориальным распределительным
//       сетям утверждаются на период регулирования:
//     </b>
//   </p>
//   <ul>
//     <li>
//       <p>стандартизированные тарифные ставки;</p>
//     </li>
//     <li>
//       <p>
//         ставки за единицу максимальной мощности (руб./кВт) на период
//         регулирования;
//       </p>
//     </li>
//     <li>
//       <p>формула платы за технологическое присоединение.</p>
//     </li>
//   </ul>
//   <p>
//     Лицо, которое имеет намерение осуществить технологическое
//     присоединение к электрическим сетям, вправе самостоятельно выбрать вид
//     ставки платы за технологическое присоединение. Выбор ставки платы
//     осуществляется заявителем на стадии заключения договора об
//     осуществлении технологического присоединения. В случае, если заявитель
//     не выбрал вид ставки, сетевая организация вправе самостоятельно
//     выбрать ставку и произвести расчет размера платы за технологическое
//     присоединение.
//   </p>
//   <p>
//     <b>
//       Согласно Правил внесение платы заявителями, юридическими лицами или
//       индивидуальным предпринимателем в целях технологического
//       присоединения по одному источнику электроснабжения энергопринимающих
//       устройств, максимальная мощность которых составляет свыше 15 до 150
//       кВт включительно (с учетом ранее присоединенных в данной точке
//       присоединения энергопринимающих устройств) осуществляется в
//       следующем порядке:
//     </b>
//   </p>
//   <p></p>
//   <ul>
//     <li>
//       <p>
//         15 процентов платы за технологическое присоединение вносятся в
//         течение 15 дней с даты заключения договора;
//       </p>
//     </li>
//     <li>
//       <p>
//         30 процентов платы за технологическое присоединение вносятся в
//         течение 60 дней с даты заключения договора, но не позже даты
//         фактического присоединения;
//       </p>
//     </li>
//     <li>
//       <p>
//         45 процентов платы за технологическое присоединение вносятся в
//         течение 15 дней со дня фактического присоединения;
//       </p>
//     </li>
//     <li>
//       <p>
//         10 процентов платы за технологическое присоединение вносятся в
//         течение 15 дней со дня подписания акта об осуществлении
//         технологического присоединения.
//       </p>
//     </li>
//   </ul>
//   <p></p>
//   <p>
//     <b>
//       Для заявителей, максимальная мощность энергопринимающих устройств
//       которых составляет менее 670 кВт, внесение платы за технологическое
//       присоединение (за исключением случаев, урегулированных предыдущим
//       абзацем осуществляется в следующем порядке:
//     </b>
//   </p>
//   <p></p>
//   <ul>
//     <li>
//       <p>
//         10 процентов платы за технологическое присоединение вносятся в
//         течение 15 дней со дня заключения договора;
//       </p>
//     </li>
//     <li>
//       <p>
//         30 процентов платы за технологическое присоединение вносятся в
//         течение 60 дней со дня заключения договора;
//       </p>
//     </li>
//     <li>
//       <p>
//         20 процентов платы за технологическое присоединение вносятся в
//         течение 180 дней со дня заключения договора;
//       </p>
//     </li>
//     <li>
//       <p>
//         30 процентов платы за технологическое присоединение вносятся в
//         течение 15 дней со дня фактического присоединения;
//       </p>
//     </li>
//     <li>
//       <p>
//         10 процентов платы за технологическое присоединение вносятся в
//         течение 10 дней со дня подписания акта об осуществлении
//         технологического присоединения.
//       </p>
//     </li>
//   </ul>
//   <p></p>
//   <p>
//     В отношении заявителей, юридических лиц или индивидуальных
//     предпринимателей в целях технологического присоединения по одному
//     источнику электроснабжения энергопринимающих устройств, максимальная
//     мощность которых составляет свыше 15 до 150 кВт включительно (с учетом
//     ранее присоединенных в данной точке присоединения энергопринимающих
//     устройств), в договоре (по желанию таких заявителей) предусматривается
//     беспроцентная рассрочка платежа в размере 95 процентов платы за
//     технологическое присоединение с условием ежеквартального внесения
//     платы равными долями от общей суммы рассрочки на период до 3 лет с
//     даты подписания сторонами акта об осуществлении технологического
//     присоединения.
//   </p>
// </div>
// <br />

//       {/* Старые документы */}
//       {/* <div className="row-docs-age">
//         <a
//           className="doc-line"
//           href={`${addressServer}/uploads/Rasporyazhenie_komiteta_po_czenam_i_tarifam_Moskovskoj_oblasti_ot_28_12_2022_286_R_5f6d2d481b.pdf?updated_at=2023-01-09T13:16:51.217Z`}
//           download=""
//           rel="noopener noreferrer"
//           target="_blank"
//         >
//           <div className="doc-line__wrap-icon">
//             <img src={pdf} alt="icon pdf" />
//           </div>
//           <div className="doc-line__wrap-text">
//             <span className="doc-line__name">
//               Распоряжение Комитета по ценам и тарифам Московской области от
//               28.12.2022 N 286-Р. "О внесении изменения в распоряжение Комитета
//               по ценам и тарифам Московской области от 20.11.2022 № 215-Р "Об
//               установлении стандартизированных тарифных ставок и формул платы за
//               технологическое присоединение энергопринимающих устройств
//               потребителей электрической энергии, объектов электросетевого
//               хозяйства, принадлежащих сетевым организациям и иным лицам, к
//               электрическим сетям территориальных сетевых организаций на
//               территории Московской области на период с 01.12.2022 по
//               31.12.2023"
//             </span>
//             <span className="doc-line__file-info">pdf, 950 кб</span>
//           </div>
//         </a>
//       </div> */}

//       {/* <div className="row-docs-age">
//         <a
//           className="doc-line"
//           href={`${addressServer}/uploads/286_R_20_12_2022_compressed_c375c2fe74.pdf?updated_at=2023-01-16T13:29:30.282Z`}
//           download=""
//           rel="noopener noreferrer"
//           target="_blank"
//         >
//           <div className="doc-line__wrap-icon">
//             <img src={pdf} alt="icon pdf" />
//           </div>
//           <div className="doc-line__wrap-text">
//             <span className="doc-line__name">
//               Распоряжение Комитета по ценам и тарифам Московской области от
//               20.12.2021 № 286-Р "Об установлении единых (котловых) тарифов на
//               услуги по передаче электрической энергии по сетям на территории
//               Московской области на 2022 год"
//             </span>
//             <span className="doc-line__file-info">pdf, 4 мб</span>
//           </div>
//         </a>
//       </div> */}

//       {/* <div className="row-docs-age">
//         <a
//           className="doc-line"
//           href={`${addressServer}/uploads/255_R_19_12_2022_compressed_61a3cca946.pdf?updated_at=2023-01-16T13:29:30.040Z`}
//           download=""
//           rel="noopener noreferrer"
//           target="_blank"
//         >
//           <div className="doc-line__wrap-icon">
//             <img src={pdf} alt="icon pdf" />
//           </div>
//           <div className="doc-line__wrap-text">
//             <span className="doc-line__name">
//               Распоряжение Комитета по ценам и тарифам Московской области от
//               19.12.2022 № 255-Р "О внесении изменений в распоряжение Комитета
//               по ценам и тарифам Московской области от 20.11.2022 № 215-Р "Об
//               установлении стандартизированных тарифных ставок и формул платы за
//               технологическое присоединение энергопринимающих устройств
//               потребителей электрической энергии, объектов электросетевого
//               хозяйства, принадлежащих сетевым организациям и иным лицам, к
//               электрическим сетям территориальных сетевых организаций на
//               территории Московской области на период с 01.12.2022 по
//               31.12.2023"
//             </span>
//             <span className="doc-line__file-info">pdf, 640 кб</span>
//           </div>
//         </a>
//       </div> */}

//     </div>
//   );
// }

// // /uploads/286_R_20_12_2022_compressed_c375c2fe74.pdf?updated_at=2023-01-16T13:29:30.282Z
// // /uploads/255_R_19_12_2022_compressed_61a3cca946.pdf?updated_at=2023-01-16T13:29:30.040Z
